/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useSelector } from 'react-redux';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const TWUserDetails = (props:any) =>
{
	const { joinDetails } = props;
	const userData = useSelector((state:any) => state?.mysession?.session);
	const [ open, setOpen ] = useState(null);

	const handleOpen = (e:any) =>
	{
		setOpen(e?.target);
	};
	const ITEM_HEIGHT = 48;

	return (
		<div className='resflexColRow'>
			<div className='flexAutoRow hostDetailWidth pdngXS'>
				<div className='flexCol'>
					<div className='flexRow pdngXXS'>
						<span className='headingMD fontWeightMD'>Host</span>
					</div>
					<div className='flexRow alignCntr  pdngXXS'>
						<div className='flexAutoRow imgAvatarNewsSM brdrBlackSM brdrRadius50 avatarBgColor'>
							<LazyLoadImage
								src={joinDetails?.creatorData[0]?.profileImage ||
									joinDetails?.creatorData[0]?.thumbnailImage ||
								'/images/icons/defaultUser.svg'}
								alt='img'
								className='brdrRadius50'
								delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME}
								effect={process.env.REACT_APP_EFFECT}
								width={`${process.env.REACT_APP_IMG_WIDTH}%`}
								height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
							/>
						</div>
						<div className='flexMinWidthCol pdngHXS wordBreakAll respdngHSM'>
							<span className='capitalTxt ellipsisTxtAutoWidth headingMD'>
								{joinDetails?.creatorData[0]?.name || ''}
							</span>
							<span className='headingXSM'>{userData?.department || ''}</span>
						</div>
					</div>
				</div>
			</div>
			{joinDetails?.coHostData?.length > 0 &&
				<div className='flexMinWidthRow coHostDetailWidth pdngXS'>
					<div className='flexCol'>
						<span className='headingMD fontWeightMD'>Co-Host</span>
						{
							joinDetails?.coHostData?.slice(0, 1)?.map((coHost:any, index:any) =>
							{
								const coHostImage = coHost?.profileImage || coHost?.thumbnailImage || '/images/icons/defaultUser.svg';

								return (
									<div className='flexRow mrgnVSM' key={coHost?._id ? coHost?._id : index}>
										<div className='flexAutoRow imgAvatarNewsSM brdrBlackSM brdrRadius50 avatarBgColor'>
											<LazyLoadImage
												src={coHostImage}
												alt='img'
												className='brdrRadius50'
												delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME}
												effect={process.env.REACT_APP_EFFECT}
												width={`${process.env.REACT_APP_IMG_WIDTH}%`}
												height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
											/>
										</div>
										<div className='coHostMinWidthCol pdngHXS wordBreakAll respdngHSM'>
											<span className='capitalTxt ellipsisTxtAutoWidth headingMD'>
												{coHost?.name || coHost?.email}
											</span>
											<span className='headingXSM'>Co-Hosted</span>
										</div>
										{index === 0 && joinDetails?.coHostData?.length > 1 &&
											<button tabIndex={0} onKeyUp={(e) => e.key === 'Enter' && handleOpen(e)} onClick={handleOpen}
												className='flexAutoRow alignCntr justifyCntr imgAvatarNewsSM brdrBlackSM brdrRadius50 userCount pointer'
											>
												<span className='whiteTxt'>+{joinDetails?.coHostData?.length - 1}</span>
											</button>}
									</div>
								);
							}

							)
						}
						<Menu
							id='basic-menu'
							anchorEl={open}
							open={Boolean(open)}
							onClose={() => handleOpen(null)}
							MenuListProps={{
								'aria-labelledby' : 'basic-button'
							}}
							PaperProps={{
								style : {
									maxHeight : ITEM_HEIGHT * 4.5,
									width     : '22ch'
								}
							}}
						>
							{joinDetails?.coHostData.slice(1).map((coHost) =>
								(<MenuItem key={coHost?._id} onClick={() => handleOpen(null)}>
									<div className='flexRow alignCntr'>
										<div className='flexAutoRow imgAvatarNewsSM brdrBlackSM brdrRadius50 countBgColor'>
											<LazyLoadImage
												src={coHost?.profileImage || coHost?.thumbnailImage || '/images/icons/defaultUser.svg'}
												alt='img'
												className='brdrRadius50'
												delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME}
												effect={process.env.REACT_APP_EFFECT}
												width={`${process.env.REACT_APP_IMG_WIDTH}%`}
												height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
											/>
										</div>
										<div className='flexMinWidthRow respdngHSM'>
											{coHost?.name || coHost?.email}
										</div>
									</div>
								</MenuItem>
								)
							)}
						</Menu>
					</div>
				</div>}
		</div>
	);
};

export default TWUserDetails;
